import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board8 from '../images/board8.jpg'

export function A08({ index }) {
  return (
    <Article
      index={index}
      heading="Using permanent functions, the app can power other apps and services."
      image={board8}
      imageDescription="CanCan is surrounded by a robust ecosystem of user-created apps using its service."
    >
      <div className="article-row">
        <span>
          <p>
            The Internet Computer was designed and built to widely foster
            innovation rather than accelerate the creation of tech monopolies
            through network effects.
            <br />
            <br />
            Under this vision, CanCan can exist as a service that runs natively
            on the internet. It can even help other entrepreneurs bootstrap
            other services.
            <br />
            <br />
            A CanCan could create the equivalent of an API endpoint for sharing
            its videos with other apps,. but unlike conventional apps, CanCan
            developers could mark certain APIs as “permanent.” This way, if
            there are ever hundreds of thousands of apps using the CanCan API,
            their developers can be assured that CanCan will never deprecate the
            API.
            <br />
            <br />
            The ability to build on permanent APIs unlocks the potential for
            apps and services to be built on functions that they can rely on.
            Recent history is full of examples of apps and services that were
            built on other services and became hostage or killed off due to
            changes in the underlying APIs. Permanent APIs allow for the
            building of complementary services without such fears — unlocking a
            wave of talent and innovation.
          </p>
        </span>
        <aside>
          <h4>Permanent Functions</h4>
          <p>
            Canisters allow functions to be marked as permanent, which means
            they cannot be deprecated across updates. This is a promise from the
            developer to the users of the function, whether they are people or
            other services.
          </p>
        </aside>
      </div>
    </Article>
  )
}

A08.propTypes = {
  index: PropTypes.number.isRequired,
}
